import React from "react";
import { Link } from "react-router-dom";

const AboutFeature: React.FC = () => {
  const features = [
    {
      icon: "flaticon-lecture",
      title: "Our Support Center",
      description:
        "Your Satisfaction is our top Priority.",
      color: "#00f6ff",
    },
    {
      icon: "flaticon-online-learning-1",
      title: "Learn Digitally with Us",
      description:
        "We are Providing you the Best Education Possible at your Home.",
      color: "#8b7cff",
    },
    {
      icon: "flaticon-guarantee",
      title: "Focus on Success",
      description:
        "Focus on the Journey not the Destination",
      color: "#00f6ff",
    },
  ];

  return (
    <section
      className="space-ptb"
      style={{
        position: "relative",
        overflow: "hidden",

        background:
          "linear-gradient(135deg, #020306 0%, #050912 50%, #020306 100%)",

        color: "#ffffff",

        borderTop:
          "1px solid rgba(0,246,255,0.10)",

        borderBottom:
          "1px solid rgba(0,246,255,0.12)",

        boxShadow:
          "inset 0 1px 0 rgba(255,255,255,0.02)",
      }}
    >
      {/* ======================================================
          BACKGROUND GRID
      ====================================================== */}

      <div
        style={{
          position: "absolute",
          inset: 0,

          pointerEvents: "none",

          opacity: 0.07,

          backgroundImage:
            "linear-gradient(rgba(255,255,255,0.05) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.05) 1px, transparent 1px)",

          backgroundSize: "34px 34px",
        }}
      />

      {/* ======================================================
          LEFT CYAN GLOW
      ====================================================== */}

      <div
        style={{
          position: "absolute",

          width: "350px",
          height: "350px",

          left: "-180px",
          top: "-150px",

          borderRadius: "50%",

          background:
            "rgba(0,246,255,0.065)",

          filter: "blur(100px)",

          pointerEvents: "none",
        }}
      />

      {/* ======================================================
          RIGHT PURPLE GLOW
      ====================================================== */}

      <div
        style={{
          position: "absolute",

          width: "350px",
          height: "350px",

          right: "-180px",
          bottom: "-180px",

          borderRadius: "50%",

          background:
            "rgba(139,92,255,0.07)",

          filter: "blur(100px)",

          pointerEvents: "none",
        }}
      />

      {/* ======================================================
          CONTENT
      ====================================================== */}

      <div
        className="container"
        style={{
          position: "relative",
          zIndex: 2,
        }}
      >
        {/* ==================================================
            SECTION HEADING
        ================================================== */}

        <div className="row justify-content-center mb-5">
          <div className="col-lg-8 text-center">

            <div
              style={{
                display: "inline-flex",

                alignItems: "center",

                gap: "8px",

                marginBottom: "14px",

                padding: "6px 13px",

                border:
                  "1px solid rgba(0,246,255,0.18)",

                borderRadius: "4px",

                background:
                  "rgba(0,246,255,0.025)",

                color: "#00f6ff",

                fontSize: "9px",

                fontWeight: 700,

                letterSpacing: "2px",

                textTransform:
                  "uppercase",
              }}
            >
              <span
                style={{
                  width: "6px",
                  height: "6px",

                  borderRadius: "50%",

                  background:
                    "#00f6ff",

                  boxShadow:
                    "0 0 10px #00f6ff",
                }}
              />

              WHY GROWNIVERSE
            </div>

            <h2
              style={{
                color: "#ffffff",

                fontSize:
                  "clamp(28px, 4vw, 40px)",

                fontWeight: 800,

                lineHeight: 1.2,

                marginBottom: "15px",

                letterSpacing: "-0.5px",

                textShadow:
                  "0 0 25px rgba(255,255,255,0.07)",
              }}
            >
              Learn. Grow. Succeed.
            </h2>

            <div
              style={{
                width: "70px",

                height: "2px",

                margin:
                  "0 auto 18px",

                background:
                  "linear-gradient(90deg, #00f6ff, #8b7cff)",

                boxShadow:
                  "0 0 10px rgba(0,246,255,0.5)",
              }}
            />

            <p
              style={{
                color: "#8d9aaa",

                fontSize: "14px",

                lineHeight: 1.8,

                maxWidth: "650px",

                margin:
                  "0 auto",
              }}
            >
              Everything you need to build your
              knowledge, develop your skills and
              move towards success.
            </p>
          </div>
        </div>

        {/* ==================================================
            FEATURE CARDS
        ================================================== */}

        <div className="row g-4">
          {features.map((feature, index) => (
            <div
              className="col-md-4"
              key={index}
            >
              <div
                style={{
                  position: "relative",

                  height: "100%",

                  minHeight: "280px",

                  padding: "35px 25px",

                  textAlign: "center",

                  background:
                    "linear-gradient(145deg, rgba(255,255,255,0.035), rgba(255,255,255,0.012))",

                  border:
                    "1px solid rgba(255,255,255,0.08)",

                  borderRadius: "10px",

                  boxShadow:
                    "0 20px 50px rgba(0,0,0,0.35), inset 0 0 25px rgba(255,255,255,0.008)",

                  overflow: "hidden",
                }}
              >
                {/* Top glowing line */}

                <div
                  style={{
                    position: "absolute",

                    top: 0,

                    left: "20%",

                    width: "60%",

                    height: "1px",

                    background:
                      `linear-gradient(90deg, transparent, ${feature.color}, transparent)`,

                    boxShadow:
                      `0 0 10px ${feature.color}`,
                  }}
                />

                {/* Corner glow */}

                <div
                  style={{
                    position: "absolute",

                    width: "120px",
                    height: "120px",

                    top: "-70px",
                    right: "-60px",

                    borderRadius: "50%",

                    background:
                      feature.color,

                    opacity: 0.045,

                    filter: "blur(35px)",
                  }}
                />

                {/* ==================================================
                    ICON
                ================================================== */}

                <div
                  style={{
                    width: "76px",
                    height: "76px",

                    margin:
                      "0 auto 22px",

                    borderRadius: "50%",

                    display: "flex",

                    alignItems: "center",

                    justifyContent: "center",

                    border:
                      `1px solid ${feature.color}40`,

                    background:
                      `${feature.color}08`,

                    boxShadow:
                      `0 0 25px ${feature.color}12`,
                  }}
                >
                  <i
                    className={`${feature.icon} fz50`}
                    style={{
                      color:
                        feature.color,

                      fontSize: "34px",

                      textShadow:
                        `0 0 15px ${feature.color}55`,
                    }}
                  />
                </div>

                {/* ==================================================
                    TITLE
                ================================================== */}

                <h4
                  style={{
                    color: "#ffffff",

                    fontSize: "19px",

                    fontWeight: 700,

                    marginBottom: "13px",
                  }}
                >
                  {feature.title}
                </h4>

                {/* ==================================================
                    DESCRIPTION
                ================================================== */}

                <p
                  style={{
                    color: "#8d9aaa",

                    fontSize: "13px",

                    lineHeight: 1.7,

                    minHeight: "45px",

                    marginBottom: "20px",
                  }}
                >
                  {feature.description}
                </p>

                {/* ==================================================
                    BUTTON
                ================================================== */}

                <Link
                  to="#"
                  style={{
                    display: "inline-flex",

                    alignItems: "center",

                    justifyContent: "center",

                    padding:
                      "8px 18px",

                    border:
                      `1px solid ${feature.color}55`,

                    borderRadius: "5px",

                    background:
                      `${feature.color}08`,

                    color:
                      feature.color,

                    textDecoration:
                      "none",

                    fontSize: "11px",

                    fontWeight: 700,

                    letterSpacing:
                      "1px",

                    textTransform:
                      "uppercase",

                    transition:
                      "all 0.25s ease",
                  }}
                >
                  Start Now
                </Link>

                {/* Bottom scan line */}

                <div
                  style={{
                    position: "absolute",

                    bottom: 0,

                    left: "15%",
                    right: "15%",

                    height: "1px",

                    background:
                      `linear-gradient(90deg, transparent, ${feature.color}55, transparent)`,
                  }}
                />
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* ======================================================
          BOTTOM SCAN LINE
      ====================================================== */}

      <div
        style={{
          position: "absolute",

          bottom: 0,

          left: "18%",
          right: "18%",

          height: "1px",

          background:
            "linear-gradient(90deg, transparent, rgba(0,246,255,0.35), transparent)",

          pointerEvents: "none",
        }}
      />
    </section>
  );
};

export default AboutFeature;